var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9807 37.5865C34.334 37.4127 34.7584 37.4422 35.0627 37.692C37.1517 39.4061 38.8671 41.5561 40.0694 44.0028C40.381 44.637 39.8998 45.3496 39.1933 45.3496H37.7618C37.3834 45.3496 37.0408 45.1332 36.8515 44.8055C35.8596 43.0889 34.6646 42.1807 33.8293 41.5078C33.5214 41.2599 33.0996 41.1917 32.7337 41.3412C29.563 42.6371 26.6147 43.2096 23 43.21C19.3851 43.2096 16.4362 42.6372 13.2653 41.3412C12.8994 41.1917 12.4776 41.2598 12.1697 41.5078C11.3344 42.1807 10.1394 43.0889 9.14753 44.8055C8.95823 45.1332 8.61559 45.3496 8.2372 45.3496H6.80575C6.09918 45.3496 5.61799 44.637 5.9296 44.0028C7.13189 41.5562 8.84737 39.4061 10.9363 37.692C11.2407 37.4422 11.665 37.4127 12.0184 37.5865C15.1819 39.1422 19.0834 39.8639 23 39.8643C26.9164 39.8638 30.8173 39.1421 33.9807 37.5865ZM16.2109 2.77734C20.7645 1.74189 24.2131 1.7409 28.7666 2.77637C30.508 3.17237 31.6885 4.76493 31.6885 6.55078C31.6885 6.58625 31.7081 6.61884 31.7393 6.63564C35.8959 8.87083 39.05 12.6128 41.04 16.8329C41.209 17.1912 41.5661 17.4258 41.9623 17.4258H42C44.2091 17.4258 46 19.2166 46 21.4258V27.3877C46 29.2334 44.7496 30.786 43.05 31.2472C43.0162 31.2564 42.9893 31.2826 42.9807 31.3166C42.9701 31.3589 42.9319 31.3877 42.8883 31.3877H40.6886C39.9629 31.3877 39.4723 30.6334 39.6676 29.9344C39.9375 28.9685 40.082 27.9205 40.082 26.7871C40.082 18.0844 33.8648 7.65144 23.001 7.65039C12.1371 7.64953 5.91699 18.0836 5.91699 26.7871C5.91703 27.9205 6.06149 28.9685 6.33143 29.9344C6.52678 30.6334 6.03618 31.3877 5.31042 31.3877H3.10994C3.06621 31.3877 3.02788 31.3588 3.01671 31.3165C3.00775 31.2826 2.98089 31.2564 2.94701 31.2472C1.24879 30.785 0 29.2324 0 27.3877V21.4258C0 19.2166 1.79086 17.4258 4 17.4258H4.0368C4.43291 17.4258 4.79007 17.1912 4.95904 16.833C6.71239 13.1154 9.36947 9.76953 12.8188 7.49728C13.1084 7.30657 13.2891 6.98622 13.2891 6.63953V6.55078C13.2891 4.765 14.4697 3.17342 16.2109 2.77734Z",
    fill: "url(#paint0_linear_1779_3266)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.001 10.5007C27.4986 10.5011 30.9859 12.6441 33.3623 15.7078C35.7466 18.7818 36.9999 22.771 37 26.3933C37 29.9283 35.3031 32.4301 32.7148 34.0701C30.1049 35.7237 26.5818 36.5004 23.001 36.5007H22.999C19.4182 36.5004 15.8951 35.7238 13.2852 34.0701C10.697 32.43 9 29.9283 9 26.3933C9.00006 22.7708 10.254 18.7818 12.6387 15.7078C15.0156 12.6438 18.5033 10.5004 23.001 10.5007Z",
    fill: "url(#paint1_radial_1779_3266)",
    stroke: "url(#paint2_linear_1779_3266)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1921 27.3982C29.8855 27.3982 30.3999 28.0479 30.1271 28.6853C28.9453 31.4464 26.1996 33.3815 22.9991 33.3816C19.7982 33.3816 17.0524 31.4461 15.8708 28.6848C15.5981 28.0476 16.1123 27.3982 16.8054 27.3982C17.3029 27.3982 17.7254 27.7442 17.9157 28.2038C18.7411 30.1982 20.7053 31.6012 22.9981 31.6013C25.2909 31.6013 27.2557 30.1985 28.0813 28.2042C28.2717 27.7443 28.6944 27.3982 29.1921 27.3982Z",
    fill: "#6138F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1779_3266",
    x1: 7.66667,
    y1: 11.7109,
    x2: 41.3049,
    y2: 45.3491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6138F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F373FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18DCCF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1779_3266",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0022 17.6473) rotate(90) scale(19.8355 19.3826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1779_3266",
    x1: 23,
    y1: 10.0007,
    x2: 23,
    y2: 37.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6138F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#18DCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F373FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.1db162eea63cf1db06d81ca71b3ec64b.svg";
export { ForwardRef as ReactComponent };